import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _excluded = ["dataTestId", "id", "text"];

var _templateObject, _templateObject2, _templateObject3;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { getRem, typographyCaption, wordBreak } from "./../../core";
import { IconErrorOutlined } from "./../../icons";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var paddingSize = getRem('12px');
var iconSize = getRem('16px');
var StyledInputErrorText = styled.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n  ", "\n    align-items: center;\n  box-sizing: border-box;\n  color: ", ";\n  display: flex;\n  margin-top: ", ";\n  padding-left: ", ";\n  padding-right: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return typographyCaption(theme);
}, wordBreak, function (_ref2) {
  var theme = _ref2.theme;
  return theme.color.system.negative[500].value;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.size.spacing.small.value;
}, paddingSize, paddingSize);
var StyledInputErrorTextContent = styled.span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  min-width: 0;\n  width: 100%;\n"])));
var StyledOutlinedErrorIcon = styled(IconErrorOutlined)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  align-self: flex-start;\n  display: flex;\n  fill: ", ";\n  flex-shrink: 0;\n  height: ", ";\n  margin-right: ", ";\n  width: ", ";\n"])), function (_ref4) {
  var theme = _ref4.theme;
  return theme.color.system.negative[500].value;
}, iconSize, function (_ref5) {
  var theme = _ref5.theme;
  return theme.size.spacing.small.value;
}, iconSize);

var InputErrorText = function InputErrorText(_ref6) {
  var dataTestId = _ref6.dataTestId,
      id = _ref6.id,
      text = _ref6.text,
      other = _objectWithoutProperties(_ref6, _excluded);

  return /*#__PURE__*/_jsxs(StyledInputErrorText, _objectSpread(_objectSpread({
    id: id,
    "data-testid": dataTestId,
    role: "alert"
  }, other), {}, {
    children: [/*#__PURE__*/_jsx(StyledOutlinedErrorIcon, {
      "data-testid": dataTestId ? "".concat(dataTestId, "-icon") : undefined
    }), /*#__PURE__*/_jsx(StyledInputErrorTextContent, {
      "data-testid": dataTestId ? "".concat(dataTestId, "-text") : undefined,
      children: text
    })]
  }));
};

InputErrorText.displayName = "InputErrorText";
InputErrorText.propTypes = {
  /** provides data-testid for functional tests */
  dataTestId: PropTypes.string,

  /** Unique identificator. Necessary to have for linking with other components */
  id: PropTypes.string.isRequired,

  /** Displays provided text */
  text: PropTypes.node.isRequired
};
export { InputErrorText };